export const CHECK_ACCOUNT_API_CALLED = 'CHECK_ACCOUNT_API_CALLED';
export const CREATE_ACCOUNT_POST_REQUEST = 'CREATE_ACCOUNT_POST_REQUEST';
export const CREATE_ACCOUNT_POST_REQUEST_ERROR = 'CREATE_ACCOUNT_POST_REQUEST_ERROR';
export const CREATE_ACCOUNT_POST_REQUEST_SUCCESS = 'CREATE_ACCOUNT_POST_REQUEST_SUCCESS';
export const ENROLL_REWARD_LINK = 'ENROLL_REWARD_LINK';
export const ENROLL_REWARD_LINK_ERROR = 'ENROLL_REWARD_LINK_ERROR';
export const ENROLL_REWARD_LINK_SUCCESS = 'ENROLL_REWARD_LINK_SUCCESS';
export const GET_ACCOUNT_BY_EMAIL = 'GET_ACCOUNT_BY_EMAIL';
export const IS_EMAIL_ACCOUNT_EXIST = 'IS_EMAIL_ACCOUNT_EXIST';
export const SET_ORDER_SOURCE = 'SET_ORDER_SOURCE';
export const SET_XSESSIONID = 'SET_XSESSIONID';
